// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateAlarmRulesGroup_wrapper__bJNxE","modal":"CreateAlarmRulesGroup_modal__n5c4j","tips":"CreateAlarmRulesGroup_tips__TZqz9","red":"CreateAlarmRulesGroup_red__GAMoY"};